import React, { useState } from "react";

const TABS = [["by_state", "By state", "state"], ["by_page", "By landing page", "page"], ["by_source", "By traffic source", "source"]];
const money = (n) => `$${Number(n || 0).toLocaleString(undefined, { maximumFractionDigits: 2 })}`;

export const ResultsBreakdown = ({ data, showPrices, onFilter }) => {
  const [tab, setTab] = useState("by_state");
  const [, , filterKey] = TABS.find((t) => t[0] === tab);
  const rows = data?.[tab] || [];
  const th = "text-left py-2 px-3 text-[10px] uppercase tracking-widest";
  return (
    <section className="brut-card bg-white mb-6" data-testid="results-breakdown">
      <div className="flex flex-wrap gap-1.5 p-3 border-b-2 border-black">
        {TABS.map(([key, label]) => (
          <button key={key} type="button" onClick={() => setTab(key)} data-testid={`results-breakdown-tab-${key}`}
                  className={`border-2 border-black px-2.5 py-1 text-[10px] uppercase tracking-widest ${tab === key ? "bg-black text-white" : "bg-white hover:bg-zinc-100"}`}>
            {label}
          </button>
        ))}
        <span className="label-mono self-center ml-auto hidden sm:inline">Click a row to filter</span>
      </div>
      <div className="overflow-x-auto max-h-80 overflow-y-auto">
        <table className="w-full text-xs min-w-[520px]" data-testid={`results-breakdown-table-${tab}`}>
          <thead className="bg-zinc-100 border-b-2 border-black sticky top-0">
            <tr>
              <th className={th}>{TABS.find((t) => t[0] === tab)[1].replace("By ", "")}</th>
              <th className={th}>Generated</th><th className={th}>Sold</th><th className={th}>Pending</th>
              <th className={th}>Bad</th><th className={th}>Rejected</th>
              {showPrices && <th className={th}>Sold for</th>}
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.key} onClick={() => r.key !== "—" && onFilter(filterKey, r.key)}
                  className="border-b border-zinc-200 hover:bg-zinc-50 cursor-pointer" data-testid={`results-breakdown-row-${r.key}`}>
                <td className="py-1.5 px-3 font-mono font-bold">{r.key}</td>
                <td className="py-1.5 px-3">{r.generated}</td><td className="py-1.5 px-3">{r.sold}</td>
                <td className="py-1.5 px-3">{r.pending}</td><td className="py-1.5 px-3">{r.bad}</td>
                <td className="py-1.5 px-3">{r.rejected}</td>
                {showPrices && <td className="py-1.5 px-3">{money(r.revenue)}</td>}
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={7} className="py-6 text-center label-mono text-zinc-500">No leads in this range</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
};
